export enum StudentRouteName {
  StudentHome = 'StudentHome',
  Absences = 'Absences',
  Agenda = 'Agenda',
  AroundTheWorld = 'AroundTheWorld',
  Chat = 'Chat',
  News = 'News',
  NewsDetail = 'NewsDetail',
  Notes = 'Notes',
  PartnershipUniversities = 'PartnershipUniversities',
  Business = 'Business',
  Shop = 'Shop',
  StageAlternance = 'StageAlternance',
  StageAlternanceForm = 'StageAlternanceForm',
}

export enum EmployeeRouteName {
  EmployeeHome = 'EmployeeHome',
  RoomsPlanning = 'RoomsPlanning',
  RoomsDisponibilities = 'RoomsDisponibilities',
  EmployeeNews = 'EmployeeNews',
  EmployeeNewsDetail = 'EmployeeNewsDetail',
  AroundTheWorldManagement = 'AroundTheWorldManagement',
  AroundTheWorldManagementMap = 'AroundTheWorldManagementMap',
  MenuManagement = 'MenuManagement',
}

export enum CommonRoutesName {
  Login = 'Login',
  NotAllowed = 'NotAllowed',
  NotFound = 'NotFound',
  Settings = 'Settings',
  Home = 'Home',
  ConfigTest = 'ConfigTest',
  Business = 'Business',
}
